import { Component, OnInit } from "@angular/core";
import { SpecialitesService } from "../services/specialites/specialites.service";
import { UsersService } from "../services/users/users.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";

@Component({
    selector: "app-adauga-bilet",
    templateUrl: "./adauga-bilet.component.html",
    styleUrls: ["./adauga-bilet.component.scss"],
})
export class AdaugaBiletComponent implements OnInit {
    specialties: any[];
    healthOrganizations: any[];
    ticket: any = {};
    selectedFile: File | null = null;
    isSubmitting = false;

    types: any[] = [
        { name: "ACUT", value: "ACUT" },
        { name: "SUBACUT", value: "SUBACUT" },
        { name: "PREVENTIE", value: "PREVENTIE" },
        { name: "CRONIC", value: "CRONIC" },
        { name: "MONITORIZARE", value: "MONITORIZARE" },
    ];

    constructor(
        private specialtiesService: SpecialitesService,
        private usersService: UsersService,
        private toastr: ToastrService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.getSpecialties();
        this.getHealthOrganizations();
    }

    getSpecialties() {
        const t = this;
        this.specialtiesService.get().subscribe((data: any) => {
            t.specialties = data;
            t.specialties = t.sortAlphabethic(data);
        });
    }

    getHealthOrganizations() {
        const t = this;
        this.usersService.getInsuranceCompanies().subscribe((data: any) => {
            t.healthOrganizations = data;

            // Găsește obiectul cu label "CJAS Iasi"
            const iasi = this.healthOrganizations.find(
                (h) => h.label === "CJAS Iasi",
            );

            if (iasi) {
                // Setez ngModel cu label-ul
                this.ticket.healthOrganisation = iasi.label;
            }
        });
    }

    sortAlphabethic(item: any) {
        const t = this;
        var ar = item.sort(function (a, b) {
            var nA = a.name.toLowerCase();
            var nB = b.name.toLowerCase();
            if (nA < nB) return -1;
            else if (nA > nB) return 1;
            return 0;
        });
        return item;
    }

    onInput(event: any): void {
        let input = event.target.value;
        // Remove non-digit characters
        input = input.replace(/\D/g, "");
        // Limit to 7 characters
        if (input.length > 7) {
            input = input.slice(0, 7);
        }
        // Update the model
        this.ticket.number = input;
        // Update the input value to reflect changes
        event.target.value = input;
    }

    onInput2(event: any): void {
        let input = event.target.value;
        // Convert to uppercase and limit to 6 characters
        input = input.toUpperCase().slice(0, 6);
        // Update the model
        this.ticket.batch = input;
        // Update the input value to reflect changes
        event.target.value = input;
    }

    // ✅ METODĂ NOUĂ: Capturează fișierul selectat
    onFileSelected(event: any): void {
        const files: FileList = event.target.files;
        if (files && files.length > 0) {
            const file = files[0];

            // Validare dimensiune (max 5MB)
            const maxSize = 5 * 1024 * 1024; // 5MB in bytes
            if (file.size > maxSize) {
                this.toastr.error(
                    "Fișierul depășește 5MB",
                    "Dimensiune invalidă",
                );
                event.target.value = ""; // Reset input
                return;
            }

            this.selectedFile = file;
        }
    }

    // ✅ METODĂ NOUĂ: Șterge fișierul selectat
    removeFile(): void {
        this.selectedFile = null;
        const fileInput = document.getElementById("file") as HTMLInputElement;
        if (fileInput) {
            fileInput.value = "";
        }
    }

    // ✅ METODĂ ACTUALIZATĂ: Trimite FormData cu fișier
    addTicket() {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        const t = this;

        console.log("this.ticket", this.ticket);
        console.log("selectedFile", this.selectedFile);

        // ✅ Construiește FormData
        const formData = new FormData();

        // ✅ ticket ca STRING JSON (nu Blob) - Spring îl primește perfect
        formData.append("ticket", JSON.stringify(this.ticket));

        // ✅ Fișier opțional
        if (this.selectedFile) {
            formData.append("file", this.selectedFile, this.selectedFile.name);
        }

        // ✅ Trimite la API
        this.usersService.postExternalTicketWithFile(formData).subscribe({
            next: () => {
                t.toastr.success("Bilet adăugat cu succes", "Adăugare bilet");
                setTimeout(() => {
                    this.router.navigate(["/biletele-mele"]);
                }, 2000);
            },
            error: (err) => {
                console.error("Error adding ticket:", err);
                t.toastr.error("Adăugare eșuată", "Adăugare bilet");
            },
            complete: () => {
                this.isSubmitting = false;
            },
        });
    }

    isDisabled(): boolean {
        return (
            this.ticket.batch &&
            this.ticket.number &&
            this.ticket.diagnosticType &&
            this.ticket.senderSpecialization &&
            this.ticket.healthOrganisation &&
            this.ticket.senderDoctor
        );
    }
}
